export function isAddressAutocompleteServerEnabled() {
  if (typeof window === "undefined") return false;
  const v = window.nitromuleReactData?.addressAutocompleteAvailable;
  return v === "1" || v === 1 || v === true;
}
export function isQuotePlacesAutocompleteServerEnabled() {
  if (typeof window === "undefined") return false;
  const v = window.nitromuleReactData?.quotePlacesAutocompleteAvailable;
  return v === "1" || v === 1 || v === true;
}
